<script setup>
import {onMounted, onUnmounted, ref} from 'vue'
import axios from "axios";
import Swal from "sweetalert2";
import { useStore } from 'vuex'

import { useRouter } from 'vue-router'



const router = useRouter()
const store = useStore()
const email = ref('')
const password = ref('')
const Errorlogin = ref('')

async function login() {
  const formData = new FormData()
  formData.append('email', email.value)
  formData.append('password', password.value)


  try {
    Errorlogin.value = '';
    // const response = await axios.put("https://jsonplaceholder.typicode.com/posts/"+route.query.id)
    const response = await axios.post('https://fixstyle.ir/api/login',formData)
    // posts.value =(response.data)
    // localStorage.setItem('token', response.data.token)


    // loaded.value = false
    if (response.status === 200){

      console.log(response.data)
      store.commit('setUser', response.data.user)
      store.commit('setToken', response.data.token)

      // console.log(store.getters.getToken)
      router.push({ name: 'home' })

      /*Swal.fire({
        title: "ورود موفق",
        text: "برای ورود کلیک کنید!",
        icon: "success",
        footer: '<a href="/products">لیست کل محصولات</a>'
      });*/
    }
    else {
      Swal.fire({
        title: 'Error!',
        text: 'Do you want to continue',
        icon: 'error',
        confirmButtonText: 'Cool'
      })
    }

  } catch (err) {
    // error.value = 'خطا در دریافت اطلاعات'
    /*Swal.fire({
      title: 'Error!',
      text: 'خطا در دریافت اطلاعات',
      icon: 'error',
      confirmButtonText: 'Cool'
    })*/
    Errorlogin.value = '';
    if (err.status === 401){
      console.log("رمز عبور یا نام کاربری اشتباه است")
      Errorlogin.value="رمز عبور یا نام کاربری اشتباه است"+err.message;
      // Errorlogin.value.push("رمز عبور یا نام کاربری اشتباه است");
    }

    // console.error("Error",err.message)
  } finally {
    // loading.value = false
  }










}


const isOnline = ref(navigator.onLine)
function updateOnlineStatus() {
  isOnline.value = navigator.onLine
  if (isOnline.value){
    // clickCallback(route.query.page)
  }
}

onMounted(() => {
  window.addEventListener('online', updateOnlineStatus)
  window.addEventListener('offline', updateOnlineStatus)
})

onUnmounted(() => {
  window.removeEventListener('online', updateOnlineStatus)
  window.removeEventListener('offline', updateOnlineStatus)
})







</script>

<template>

<div class="row" v-if="!isOnline">
  <div class="col-12">
    <div  class="offline-alert">
      🔌 ارتباط با اینترنت قطع شده!
    </div>
  </div>
</div>
<div v-else  class="row justify-content-center mt-4">
  <div class="col-4 border p-4 bgcolor rounded-4">
<p>  {{Errorlogin}}</p>

    <form  @submit.prevent="login">
      <div class="mb-3">
        <label for="exampleInputEmail1" class="form-label">پست الکترونیکی</label>
        <input v-model="email" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
<!--        <div id="emailHelp" class="form-text">ما هرگز ایمیل شما را با هیچ کس دیگری به اشتراک نمی‌گذاریم</div>-->
      </div>
      <div class="mb-3">
        <label for="exampleInputPassword1" class="form-label">رمز عبور</label>
        <input v-model="password" type="password" class="form-control" id="exampleInputPassword1">
      </div>
      <div class="mb-3 form-check">
        <input type="checkbox" class="form-check-input" id="exampleCheck1">
        <label class="form-check-label mx-3" for="exampleCheck1">منو بخاطر بسپار</label>
      </div>
      <button type="submit" class="btn btn-primary">ارسال</button>
    </form>
  </div>
</div>
</template>

<style scoped>

.bgcolor{
  background: #2A7B9B;
  background: linear-gradient(90deg,rgba(42, 123, 155, 1) 0%, rgba(87, 199, 133, 1) 50%, rgb(83, 237, 220) 100%);
}
</style>